import React from 'react';
import DetailPanel from './../../core/detail';
import ClientService from '../../../../service/client';
import { connect } from 'react-redux';
import mapStateToProps from './../../../../store/map/auth-token';
import mapDispatchToProps from './../../../../store/map/on-logout';
import UserSystemsGraphViewPanel from './view';

class _UserSystemsGraphPanel extends DetailPanel
{
    constructor(parms)
    {
        super(parms);

        this.loadData = this.loadData.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.getLoadedDataDetailUi = this.getLoadedDataDetailUi.bind(this);
        this.onAuthError = this.onAuthError.bind(this);
        this.onFatalError = this.onFatalError.bind(this);
        this.onNetworkOffline = this.onNetworkOffline.bind(this);
    }

    onAuthError()
    {
        this.props.onLogout();
    }

    onFatalError()
    {
        this.props.onUpdateError(true, '');
    }

    onNetworkOffline()
    {
        this.props.onUpdateDeviceOnline(false);
    }

    getLoadDataRequest(inputObj)
    {
        return {
            targetUserId: inputObj.targetUserId
        };
    }

    loadData(inputObj)
    {
        super.loadData(inputObj);
        ClientService.getUserClientStats({
            request: this.getLoadDataRequest(inputObj),
            onResponse: this.onLoadDataResponse,
            onError: this.onLoadDataError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    componentDidMount()
    {
        const targetUserId = this.props.targetUserId;
        this.loadData({ targetUserId });
    }

    getLoadedDataDetailUi()
    {
        return (
            <section>
                <UserSystemsGraphViewPanel data={this.state.data} />
            </section>
        );
    }
}

const UserSystemsGraphPanel = connect(mapStateToProps, mapDispatchToProps)(_UserSystemsGraphPanel);
export default UserSystemsGraphPanel;